<template>
  <article class="mt-0 w-full bg-white md:mt-20 lg:mt-64">
    <div
      class="flex w-full justify-between gap-24 px-3 py-6 md:py-20 md:pl-28 md:pr-12"
    >
      <section class="w-full md:w-1/2" :class="{ 'px-3 py-6': isMobile }">
        <ProductDetailsAccordion
          v-if="isMobile"
          :product="product"
          :product-order-number="productOrderNumber"
        />
        <ProductDetailsExpanded
          v-else
          :product="product"
          :product-order-number="productOrderNumber"
        />
      </section>
      <div
        v-if="image"
        class="relative hidden w-1/2 md:block lg:-top-52 lg:-mb-52"
      >
        <ProductImage
          :image="image"
          is-pdp
          sizes="md:50vw lg:50vw xl:50vw xxl:66vw"
          low-priority
        />
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { PropType } from 'vue'
import type { Product, ProductImage } from '@scayle/storefront-nuxt'
import { getImageAssetType } from '#layers/base/utils/image'
import { useDeviceType } from '~/composables/useDeviceType'

const { isMobile } = useDeviceType()

const props = defineProps({
  product: {
    type: Object as PropType<Product | null>,
    default: () => null,
  },
  productOrderNumber: {
    type: String as PropType<string | undefined>,
    default: undefined,
  },
})

const image = computed(
  () =>
    props.product?.images?.reduce((data, image) => {
      const assetType = getImageAssetType(image)
      if (assetType === '_kb') {
        return [image, ...data]
      }
      if (assetType === '_5') {
        return [...data, image]
      }
      return data
    }, [] as Array<ProductImage>)[0],
)
</script>
